import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance16dzvgcii8pc4 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.v5z_1 = call;
        this.w5z_1 = responseData.f5l_1;
        this.x5z_1 = responseData.a5l_1;
        this.y5z_1 = responseData.d5l_1;
        this.z5z_1 = responseData.b5l_1;
        this.a60_1 = responseData.g5l_1;
        var tmp = this;
        var tmp_0 = responseData.e5l_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.b60_1 = tmp0_elvis_lhs == null ? Companion_getInstance().v4k_1 : tmp0_elvis_lhs;
        this.c60_1 = responseData.c5l_1;
      }
      l5k() {
        return this.v5z_1;
      }
      dw() {
        return this.w5z_1;
      }
      u5k() {
        return this.x5z_1;
      }
      v5k() {
        return this.y5z_1;
      }
      w5k() {
        return this.z5z_1;
      }
      x5k() {
        return this.a60_1;
      }
      t5k() {
        return this.b60_1;
      }
      y51() {
        return this.c60_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
